<template>
  <div class="core-service">
    <h2 class="title">core-service</h2>
    <p class="text">
      Combining the latest logistics technology with high - quality service, and
      the ability to offer customized solutions, WR1 global logistics services
      are ideal for customers seekings to grow their buinesses.
    </p>
    <div class="column">
      <div>
        <figure class="gi">
          <img src="@/assets/images/core-service/core-1.png" />
          <span class="title-img">LCL</span>
        </figure>
      </div>
      <div>
        <figure>
          <img src="@/assets/images/core-service/core-2.png" />
          <span class="title-img">LTL</span>
        </figure>
      </div>
      <div>
        <figure>
          <img src="@/assets/images/core-service/core-3.png" />
          <span class="title-img">CY TRUCKING</span>
        </figure>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CoreService",
};
</script>

<style lang="scss" scoped>
.core-service {
  position: relative;
  z-index: 1;
  background-color: #f8f7f7;
  padding: 20px 30px;
  @media (min-width: 900px) {
    padding: 100px 100px;
  }
  @media (min-width: 1900px) {
    padding: 70px 200px !important;
  }

  .title {
    position: relative;
    z-index: 1;
    font-weight: 800;
    font-size: 3.2rem;
    line-height: 5.3rem;
    /* identical to box height */
    text-align: center;
    letter-spacing: -0.02em;
    color: #2b938c;
    text-transform: uppercase;
    margin-bottom: 20px;
  }
  .text {
    font-size: 1.1rem;
    line-height: 1.35rem;

    letter-spacing: -0.02em;
    padding-bottom: 10px;
    color: #000;
    text-align: center;
    @media (min-width: 900px) {
      width: 60%;
    }
    margin: auto;
    margin-bottom: 50px;
  }

  .column {
    display: flex;
    justify-content: center;
    text-align: center;
    transition: 0.8s all;
    flex-direction: column;
    gap: 50px;
    align-items: center;
    margin-bottom: 50px;

    @media (min-width: 1006px) {
      flex-direction: row;
      gap: 0;
    }
    div {
      figure {
        max-width: 400px;
        position: relative;
        @media (min-width: 1006px) {
          width: 300px;
        }
        @media (min-width: 1528px) {
          width: 500px;
        }
        img {
          width: 100%;
          height: 100%;
        }
        .title-img {
          position: absolute;
          bottom: 45%;
          left: 50%;
          transform: translate(-50%);
          font-weight: 800;
          font-size: 2rem;
          line-height: 2rem;
          color: #2b938c;
          letter-spacing: -0.02em;
          -webkit-transition: all 0.5s;
          transition: all 0.5s;
          -webkit-transition-delay: 0.6s;
          transition-delay: 0.6s;
        }
      }
      figure::before {
        position: absolute;
        top: 30px;
        right: 30px;
        bottom: 30px;
        left: 30px;
        border-left: 5px solid rgba(255, 254, 254, 70%);
        content: "";
        opacity: 1;
        background-color: rgba(255, 255, 255, 0.5);
        -webkit-transition: all 0.5s;
        transition: all 0.5s;
        -webkit-transition-delay: 0.6s;
        transition-delay: 0.6s;
      }

      &:hover figure::before {
        background: rgba(255, 254, 254, 70%);
        left: 30px;
        opacity: 1;
        -webkit-transition-delay: 0s;
        transition-delay: 0s;
      }
      &:hover figure .title-img {
        bottom: 40%;
        transform: translate(-50%);
      }

      @media (min-width: 1008px) {
        figure .title-img {
          bottom: -20%;
          transform: translate(-50%);
          font-size: 1.5rem;
        }

        figure::before {
          opacity: 0;
          left: 100%;
        }
      }
    }
  }
}

@media (min-width: 900px) {
  .core-service::after {
    content: "";
    position: absolute;
    top: -10%;
    right: -31px;
    background-image: url("../../../../../assets/images/core-service/core-top.png");
    background-size: 300px 300px;
    display: inline-block;
    width: 300px;
    height: 300px;
  }
  .core-service::before {
    content: "";
    position: absolute;
    bottom: -18px;
    left: -120px;

    background-image: url("../../../../../assets/images/core-service/core-bottom.png");
    background-size: 300px 300px;
    display: inline-block;
    width: 300px;
    height: 300px;
  }
}
</style>